export const DEFAULT_PAGE = 1;

export const SEARCH_PARAM_KEY_PAGE = 'page';
export const SEARCH_PARAM_KEY_PER_PAGE = 'perPage';

export const PRODUCT_GRID = 'productGrid';
export const CARD_GRID = 'cardGrid';
export const ORDER_GRID = 'orderGrid';
